// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6bf8b40","239":"5937298d","488":"dbdd0459","732":"0caa017c"}[chunkId] + ".chunk.js";
};